import { Component, OnInit } from '@angular/core';
import { Hauler } from '../hauler.model';
import { HaulersService } from '../haulers.service';
import { Router, ActivatedRoute , Params } from '@angular/router';

@Component({
  selector: 'app-haulers-view',
  templateUrl: './haulers-view.component.html',
  styleUrls: ['./haulers-view.component.css']
})
export class HaulersViewComponent implements OnInit {
  hauler: any = {};
  id: string;

  constructor(private route: ActivatedRoute, private router: Router, private haulersService: HaulersService) { }

  ngOnInit() {
    this.route.params
      .subscribe(
        (params: Params) => {
          this.id = params['id'];
          this.haulersService.getItem(this.id).subscribe( hauler => {
            this.hauler = hauler;
            this.hauler.id = this.id;
          });
        }
      );
  }

}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/haulers/haulers-view/haulers-view.component.ts